import { render, staticRenderFns } from "./ModalBuildAwesomeKickstarter.vue?vue&type=template&id=d95425c0"
import script from "./ModalBuildAwesomeKickstarter.vue?vue&type=script&lang=js"
export * from "./ModalBuildAwesomeKickstarter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports